import { EMPLOYEE_BASE_URL, HR_BASE_URL } from "src/redux/api/appConst";
import { axiosAuth } from "src/redux/api/common";
import { EditLeaveFormValues } from "./schema";

// get leave balance
export const getLeaveBalance = async (employeeId: number) => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const { data } = await api.get(`/leaves/balance/${employeeId}`);

  return data.data;
};

export const editLeave = async ({
  id,
  values,
}: {
  id: string;
  values: EditLeaveFormValues;
}) => {
  const api = axiosAuth(HR_BASE_URL);

  const { data } = await api.put(`/leaves/${id}`, values);

  return data.data;
};

export const getLeaveDays = async (id: number) => {
  const api = axiosAuth(HR_BASE_URL);

  const { data } = await api.get(`/employee/leaves-days/${id}`);

  return data.data.leaves_days;
};
